import styled from "styled-components";
import { useAddScheduleNoteToTourGroup } from "@/reactQueryHooks";
import { useAxios } from "@/axiosProvider";
import { useState } from "react";

//------------------------------------------------------------------------------------

const NoteInput = styled.textarea`
  width: 100%;
  padding: 8px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  font-size: 12px;
  font-family: inherit;
  resize: vertical;
  min-height: 60px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 6px;
`;

const Button = styled.button`
  background-color: #228be6;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 4px 8px;
  font-size: 11px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1c7ed6;
  }

  &.cancel {
    background-color: #e9ecef;
    color: #495057;
    &:hover {
      background-color: #dee2e6;
    }
  }

  &.add {
    display: flex;
    align-items: center;
    font-size: 11px;
    padding: 4px 10px;

    &::before {
      content: "+";
      margin-right: 4px;
      font-size: 14px;
      font-weight: bold;
    }
  }
`;

const NewScheduleNote = ({
  refetch,
  tourGroupId,
}: {
  refetch: () => void;
  tourGroupId: string;
}) => {
  const { user } = useAxios();
  const [inputValue, setInputValue] = useState("");

  const {
    mutateAsync: addNewScheduleNote,
    isLoading: isAddingNewScheduleNote,
  } = useAddScheduleNoteToTourGroup() as any;

  return (
    <>
      <NoteInput
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Write a new note..."
      />
      <ButtonContainer>
        <Button
          onClick={async () => {
            try {
              if (
                !inputValue.trim() ||
                inputValue.length < 3 ||
                inputValue.length > 500
              ) {
                alert("Note must be between 3 and 500 characters.");
                return;
              }

              await addNewScheduleNote({
                tour_group_id: tourGroupId,
                note_body: inputValue,
                author_id: user?._id,
              });
              refetch();
            } catch (error) {
              alert("Error adding schedule note");
              console.error("Error adding schedule note:", error);
            }
          }}
        >
          Save
        </Button>
      </ButtonContainer>
    </>
  );
};

export default NewScheduleNote;
